import * as ng from 'angular';
import {PreviewService} from '../../../services/preview.service';

class ConservazioneController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    'store'
  ];

  constructor(
    private $scope: any,
    private $rootScope: any,
    private store: ng.a0.storage.IStoreService
  ) {
    $rootScope.accepted = false;
    $scope.pageHeader = 'Conservazione sostitutiva digitale a norma';
    $scope.user = store.get('user');
    $scope.tooltips = {
      'upload': 'Scegli una tipologia documentale, carica il documento\ne segui la procedura di conservare digitale sostitutiva.',
      'check': 'Consulta, cerca, controlla e scarica i tuoi documenti conservati.'
    };
  }

}

export const ConservazioneComponent: ng.IComponentOptions = {
  template: require('./conservazione.html'),
  controller: ConservazioneController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione.ts